var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4808 22C32.4187 22 35.3132 22.5916 38.1644 23.7747C41.0156 24.9578 43.5487 26.7314 45.7635 29.0957C46.0623 29.3944 46.2117 29.743 46.2117 30.1413C46.2117 30.5397 46.0623 30.8882 45.7635 31.187L42.3277 34.5481C42.0538 34.822 41.7362 34.9714 41.3746 34.9963C41.0131 35.0212 40.6835 34.9216 40.3857 34.6975L36.0536 31.4111C35.8545 31.2617 35.7051 31.0874 35.6055 30.8882C35.5059 30.6891 35.4561 30.465 35.4561 30.216V25.9586C34.51 25.6599 33.539 25.4233 32.5432 25.2491C31.5473 25.0748 30.5265 24.9876 29.4808 24.9876C28.4351 24.9876 27.4144 25.0748 26.4185 25.2491C25.4226 25.4233 24.4516 25.6599 23.5055 25.9586V30.216C23.5055 30.465 23.4557 30.6891 23.3561 30.8882C23.2566 31.0874 23.1072 31.2617 22.908 31.4111L18.5759 34.6975C18.2771 34.9216 17.947 35.0212 17.5855 34.9963C17.224 34.9714 16.9068 34.822 16.6339 34.5481L13.1981 31.187C12.8994 30.8882 12.75 30.5397 12.75 30.1413C12.75 29.743 12.8994 29.3944 13.1981 29.0957C15.3891 26.7304 17.9161 24.9568 20.7793 23.7747C23.6425 22.5925 26.543 22.001 29.4808 22Z",
    fill: "#DB2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.48bca324842c3b8b9ddab2744d21e5f8.svg";
export { ForwardRef as ReactComponent };